import { graphql } from 'gatsby';
import articleMapDataToComponents from '../components/article/articleMapDataToComponents';

import React from 'react';
import FeatureIntro from '../components/shared/featureIntro';
import Schedule from '../components/conference/schedule';
import Faq from '../components/conference/faq';
import HeadTags from '../components/global/headTags';
import videofeatureMapDataToComponents from './videofeatureMapDataToComponents'; //
import FeatureLayout from '../layouts/feature-layout';
import basicMapDataToComponents from './basicMapDataToComponents';
import * as style from './conference.module.scss';
import useTemplateLifecycle from '../hooks/useTemplateLifecycle';
import resolveHeaderImage from '../utils/resolveHeaderImage';
import SponsorsGrid from '../components/shared/sponsorsGrid';

const Conference = (props) => {
	const { data, location, transition } = props;
	const { startPage, isExiting, width } = useTemplateLifecycle({
		transitionStatus: transition?.status,
	});

	const {
		html_title_override,
		title,
		subheading,
		date,
		end_date,
		date_text,

		location_type,
		location_short_text,
		registration_link_text,
		registration_link_url,
		overview_text,

		featured_video_heading,
	    featured_video_subheading,
	    featured_video_youtube_id,

		schedule,
		faq,

		speakers,
		sponsors,

		meta_description,
		meta_image,
		short_description,
		featured_image,
		featured_video,
		video,
		video_embed,
		paragraphs,
		flex_content_one,
		flex_content_two,
		bottom_callouts,

		jsonId
	} = data.itemsJson ?? {};

	const { headerImage, headerTwitterImage } = resolveHeaderImage(meta_image, featured_image);

	let pageTitle = title;
	if(html_title_override) {
		pageTitle = html_title_override;
	}

	var safeTitle = (pageTitle ?? '').replace(/[^A-Z0-9]+/ig, "");

	return (
		<FeatureLayout {...props} excludeParentFunctions>
			<div className="video-feature-content-wrapper conference-wrapper">
				<HeadTags
					title={pageTitle}
					description={subheading}
					image={headerImage}
					imageTwitter={headerTwitterImage}
					location={location}
				/>

				<FeatureIntro
					heading={title}
					description={subheading}
					backgroundImage={featured_image}
					conferenceMeta={{
						date_text: date_text,
						locationText: location_short_text,
						registrationLinkUrl: registration_link_url,
						registrationLinkText: registration_link_text,
					}}
				/>

				<div className={style.overviewTextWrap}>
					<div className={style.overviewText} dangerouslySetInnerHTML={{__html: overview_text}} />
				</div>

				{featured_video_youtube_id &&
					<div
						id={`${safeTitle}AfterMovie`}
						className={`featured-video-section`}
					>
						{featured_video_heading &&
							<h2 className={`featured-video-heading`}>
								{featured_video_heading}
							</h2>
						}
						{featured_video_subheading &&
							<p className={`featured-video-subheading`}>
								{featured_video_subheading}
							</p>
						}
						<div
							className={`${style.featuredVideo} featured-video`}
						>
							<div className="video-container">
								<iframe
								src={`https://www.youtube-nocookie.com/embed/${featured_video_youtube_id}?modestbranding=1&rel=0&iv_load_policy=3`}
								referrerPolicy="strict-origin-when-cross-origin"
								allowFullScreen
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
								</iframe>
							</div>
						</div>

						<div className="featured-video-divider"></div>
					</div>
				}

				{/* SCHEDULE */}
				{(schedule ?? []).length > 0 &&
					<Schedule
						schedule={schedule ?? []}
					/>
				}

				{/* SPEAKERS */}
				{speakers && speakers.length > 0 &&
					<div className={style.speakersWrap}>
						<div id="speakers-header" className={style.speakersHeader}>
							<h1 className={style.speakersTitle}>
								Featured Speakers
							</h1>
						</div>

						<div className={style.speakersContainer}>
							<div className={style.speakersInnerContainer}>
								{speakers.length > 0 && speakers.map(function(item, i) {
									return (

										<div className={style.primaryItem}>
											<div
												className={style.bioImage} style={{ backgroundImage: 'url('+item.bio_image+')'}}
											>
												<br />
											</div>
											<h3
												className={style.staffName}
											>
												{item.name}
											</h3>
											<p
												className={style.staffPosition}
											>
												{item.position}
											</p>

											<div className={style.socialWrap}>
												{item?.social_media_link?.uri &&
													<a
														href={item?.social_media_link?.uri}
														className={`icon-social white-orange-hover`}
														target="_blank"
														rel="noopener"
													>
														<div className={`icon-twitter x-white`}></div>
													</a>
												}
												{item.linkedin_link && item.linkedin_link.uri &&
													<a
														href={item.linkedin_link.uri}
														className={`icon-social white-orange-hover fas fa-linkedin-in`}
														target="_blank"
														rel="noopener"
													>
														<span>LinkedIn</span>
													</a>
												}
												{item.threads_link && item.threads_link.uri &&
													<a
														href={item.threads_link.uri}
														className={`icon-social white-orange-hover`}
														target="_blank"
														rel="noopener"
													>
														<div className={`icon-threads x-white`}></div>
													</a>
												}
												{item.bluesky_link && item.bluesky_link.uri &&
													<a
														href={item.bluesky_link.uri}
														className={`icon-social white-orange-hover`}
														target="_blank"
														rel="noopener"
													>
														<div className={`icon-bluesky x-white`}></div>
													</a>
												}
											</div>
										</div>

									);
								})}
							</div>
						</div>
					</div>
				}
				{/* */}

				{/* FAQ */}
				{(faq ?? []).length > 0 &&
					<Faq
						faq={faq ?? []}
					/>
				}

				{flex_content_one && flex_content_one.length > 0 &&
					articleMapDataToComponents(flex_content_one, { reveal: true })
				}

				{/* SPONSORS */}
				<SponsorsGrid
					sponsors={sponsors}
					styles={style}
				/>
				{/* */}

				{bottom_callouts && bottom_callouts.length > 0 &&
					basicMapDataToComponents(bottom_callouts, { reveal: true })
				}
			</div>
		</FeatureLayout>
	);
};

// ...queryParagraphFields
// ...queryFlexContentOneFields
// ...queryFlexContentTwoFields

export default Conference;

// eslint-disable-next-line
export const ConferencePageQuery = graphql`
query conferencePageContentByPath(
	$path: String!
	$menuId: String!
	$blog: String!
	$translations: String!
  ) {
	itemsJson(path: { eq: $path }) {
		  path
		  jsonId

		  meta_description
		  meta_image {
			sizes {
			  hero_md
			  hero_sm
			}
		  }

		  short_description

		  html_title_override

		  title
		  subheading

		  date
		  end_date
		  date_text

		  location_type
		  location_short_text
		  registration_link_text
		  registration_link_url

		  overview_text

		  featured_video_heading
		  featured_video_subheading
		  featured_video_youtube_id

		  schedule {
		    day_title
			programs {
			  time
			  title
			  description
			  youtube_video_id
			  speakers {
				name
				description_plain
				social_media_link {
				uri
				title
				}
				linkedin_link {
				uri
				title
				}
				threads_link {
				uri
				title
				}
				bluesky_link {
				uri
				title
				}
				bio_image
				position
			  }
			}

		  }

		  faq {
		    question
			answer
		  }

		  speakers {
		  	id
			name
			description_plain
			social_media_link {
			  uri
			  title
			}
			linkedin_link {
			  uri
			  title
			}
			threads_link {
			  uri
			  title
			}
			bluesky_link {
			  uri
			  title
			}
			bio_image
			position
		  }

		  sponsors {
		    name
			logo_image {
			  sizes {
			    original
			  }
			}
			sponsor_url {
			  uri
			}
		  }

		  related_challenge {
			id
			title
			path
		  }

		  featured_image {
			image {
			  sizes {
				hero_lg
				hero_md
				hero_sm
				original
			  }
			}
		  }

		bottom_callouts {
			type
			items {
				title
				content_type
				path
				cta_link {
					url
					title
				}
				callout_subtitle
				image {
					sizes {
						wide_lg
						wide_md
						square_md
						original
					}

					dimensions {
						original {
							width
							height
						}
					}
					caption
					credit
					credit_plain
					alt_text
					title
				}
			}
		}

		...queryFlexContentOneFields
	}
	social: allItemsJson(filter: { id: { eq: $menuId } }) {
	  edges {
		node {
		  menu_social {
			title
			menu_name
			weight
			url
			class
			target
		  }
		}
	  }
	}

	# Index Content Data
	...headerFields
	...footerFields
	...SharedBlogFields
	...SharedTranslationsFields
	...MegaMenuFields
  }

`;
